module.exports = __webpack_public_path__ + "assets/pdf/Cycle 2 California ZEV Investment Plan.3e6ce81a.pdf";